import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Tag, Button, Space } from "antd";
import { persianDateFormat } from "./function.helper";
export const datahelper = (res: any) => {
  const newData = res.map((item: any) => {
    return {
      ...item,
      key: item.id,
      creationTime: persianDateFormat(item.creationTime),
      action: item,
    };
  });
  return newData;
};

export const columns = (lang: string, handleConfirm: any) => {
  return [
    {
      title: lang === "en-US" ? "Name" : "نام انبار",
      dataIndex: "name",
      key: "name",
      // align: "center",
    },

    {
      title: lang === "en-US" ? "AdminComment" : " یادداشت",
      dataIndex: "adminComment",
      key: "adminComment",
      // align: "center",
    },
    // {
    //   title: "AddressId",
    //   dataIndex: "addressId",
    //   key: "addressId",
    //   // align: "center",
    // },
    {
      title: lang === "en-US" ? "Order Selector" : " اولویت انبار",
      dataIndex: "orderSelector",
      key: "orderSelector",
      // align: "center",
    },
    {
      title: lang === "en-US" ? "Order Selector" : "زمان کلی ارسال",
      dataIndex: "otS_Hours",
      key: "otS_Hours",
    },

    {
      title: lang === "en-US" ? "Send Notification" : "ارسال نوتیفیکیشن",
      dataIndex: "sendNotificationOnPurchase",
      key: "sendNotificationOnPurchase",
      render: (tags: boolean) =>
        tags === true ? (
          <Tag color="green" key={0}>
            True
          </Tag>
        ) : (
          <Tag color="red" key={1}>
            False
          </Tag>
        ),
    },

    {
      title: lang === "en-US" ? "IsPrivate" : "انبار خصوصی",
      dataIndex: "isPrivate",
      key: "isPrivate",
      render: (tags: boolean) => (
        <>
          {tags === true ? (
            <Tag color="green" key={0}>
              True
            </Tag>
          ) : (
            <Tag color="red" key={1}>
              False
            </Tag>
          )}
        </>
      ),
    },
    {
      title:
        lang === "en-US" ? "orderToShipmentTimeIntervalInHours" : "زمان ارسال ",
      dataIndex: "orderToShipmentTimeIntervalInHours",
      key: "orderToShipmentTimeIntervalInHours",
    },

    {
      title:
        lang === "en-US" ? "OnlyAccessibleByEmail" : "قابل خرید با ایمیل  ",
      dataIndex: "onlyAccessibleByEmail",
      key: "onlyAccessibleByEmail",
    },
    {
      title: lang === "en-US" ? "CreationTime" : "تاریخ ایجاد  ",
      dataIndex: "creationTime",
      key: "creationTime",
      // align: "center",
    },
    {
      title: lang === "en-US" ? "َAction" : "عملیات ",
      dataIndex: "action",
      key: "action",
      render: (source: any) => (
        <>
          <Space>
            <Button
              style={{ border: "none" }}
              onClick={() => handleConfirm(source, "edit")}
            >
              <EditOutlined style={{ fontSize: "22px", color: "#1890ff" }} />
            </Button>
            <Button
              style={{ border: "none" }}
              onClick={() => handleConfirm(source, "delete")}
            >
              <DeleteOutlined style={{ fontSize: "22px", color: "#d82148" }} />
            </Button>
          </Space>
        </>
      ),
    },
  ];
};

//
